import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faTrash,
  faArrowsAlt,
  faStar,
  faTimes,
  faCopy,
  faUndo
} from '@fortawesome/free-solid-svg-icons';

interface SelectionActionBarProps {
  selectedCount: number;
  selectionType: 'files' | 'folders' | 'mixed';
  isTrashView?: boolean;
  isFavouritesView?: boolean; // Add this prop to determine the view
  onDownload?: () => void;
  onCopy: () => void;
  onMove: () => void;
  onDelete: () => void;
  onRestore?: () => void;
  onStar?: () => void;
  onClearSelection: () => void;
}

const SelectionActionBar: React.FC<SelectionActionBarProps> = ({
  selectedCount,
  selectionType,
  isTrashView = false,
  isFavouritesView = false,
  onDownload,
  onCopy,
  onMove,
  onDelete,
  onRestore,
  onStar,
  onClearSelection
}) => {
  // Role-based permissions
  const canAccess = useSelector((state: any) => state.auth.permissions?.opsmanual);
  return (
    <div className="selection-action-bar">
      <div className="selection-info">
        <span className="selection-count">{selectedCount} selected</span>
        <button className="btn-clear-selection" onClick={onClearSelection}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      
      <div className="selection-actions">
        {!isTrashView ? (
          <>
            {selectionType === 'files' && onDownload && canAccess?.['bulk-download'] && (
              <button className="action-btn" onClick={onDownload}>
                <FontAwesomeIcon icon={faDownload} />
                <span>Download</span>
              </button>
            )}
            
            {selectionType === 'files' && onStar && (
              <button className="action-btn" onClick={onStar}>
                <FontAwesomeIcon icon={faStar} />
                <span>{isFavouritesView ? 'Remove from Favourites' : 'Add to Favourites'}</span>
              </button>
            )}
            
            {canAccess?.['bulk-copy'] && (
              <button className="action-btn" onClick={onCopy}>
                <FontAwesomeIcon icon={faCopy} />
                <span>Copy</span>
              </button>
            )}
            
            {canAccess?.['bulk-move'] && (
              <button className="action-btn" onClick={onMove}>
                <FontAwesomeIcon icon={faArrowsAlt} />
                <span>Move</span>
              </button>
            )}
            
            {canAccess?.['bulk-delete'] && (
              <button className="action-btn action-btn-danger" onClick={onDelete}>
                <FontAwesomeIcon icon={faTrash} />
                <span>Delete</span>
              </button>
            )}
          </>
        ) : (
          <>
            {onRestore && canAccess?.['restore-document'] && (
              <button className="action-btn" onClick={onRestore}>
                <FontAwesomeIcon icon={faUndo} />
                <span>Restore</span>
              </button>
            )}
            
            {canAccess?.['bulk-delete'] && (
              <button className="action-btn action-btn-danger" onClick={onDelete}>
                <FontAwesomeIcon icon={faTrash} />
                <span>Delete Permanently</span>
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectionActionBar;
